'use client';
import Image from 'next/image';
import imgPeople from '@/assets/career.jpg';
import { Addcareer, UploadFile } from '@/services/career.api';
import { ChangeEvent, useState } from 'react';
import { toast } from 'react-toastify';
import { validate } from 'indicative/validator';
import { getErrorMessge } from '@/utils/helpers';

const Apply = () => {
  const [cv, setCv] = useState<any>();
  const [profileImg, setProfileImg] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email_address: '',
    name: '',
    nationality: '',
    phone_number: '',
    city: '',
    position: '',
    note: '',
  });
  const [error, setError] = useState<any>({
    email_address: '',
    name: '',
    nationality: '',
    phone_number: '',
    city: '',
    position: '',
    note: '',
    cv,
    profileImg,
  });

  const handleInputChange = (name: string, value: any) => {
    setFormData((prevState: any) => ({
      ...prevState,
      [name]: value,
    }));

    // setErrors((prevErrors: any) => ({
    //     ...prevErrors,
    //     [name]: undefined
    // }));
  };

  const handleFileUpload = (event: ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0];
    if (selectedFile) {
      if (event.target.name === 'cv') {
        setCv(selectedFile);
      } else {
        setProfileImg(selectedFile);
      }
    }
  };

  const apply = async (e: React.FormEvent) => {
    e.preventDefault();

    const fileOne = new FormData();
    const fileTwo = new FormData();
    if (cv) {
      fileOne.append('file', cv);
    }

    if (profileImg) {
      fileTwo.append('file', profileImg);
    }

    const validationRules = {
      name: 'required',
      nationality: 'required',
      phone_number: 'required',
      email_address: 'required|email',
      city: 'required',
      position: 'required',
      note: 'required',
    };

    const validationMessages = {
      'name.required': 'Full name is required',
      'nationality.required': 'Nationality is required',
      'email_address.required': 'Email address is required',
      'email_address.email': 'Email address is not valid',
      'phone_number.required': 'Phone number is required',
      'city.required': 'City is required',
      'position.min': 'Position is required',
      'note.required': 'Note is required',
    };

    if (cv === null) {
      setError({ cv: 'CV is required' });
      return;
    }
    if (profileImg === null) {
      setError({ profileImg: 'Profile Image is required' });
      return;
    }

    validate(formData, validationRules, validationMessages)
      .then(() => {
        handleUpload(fileOne, fileTwo);
      })
      .catch((error) => {
        if (Array.isArray(error)) {
          const formattedErrors: any = {};
          error.forEach((err) => {
            formattedErrors[err.field] = err.message;
          });

          setError(formattedErrors);
        }
      });
  };
  const handleUpload = async (fileOne: any, fileTwo: any) => {
    try {
      setLoading(true);
      const images = await Promise.all([
        UploadFile(fileOne),
        UploadFile(fileTwo),
      ]);

      const payload = {
        ...formData,
        cv_url: images[0].data.file_link as string,
        picture_url: images[1].data.file_link as string,
      };

      const res = await Addcareer(payload);

      toast.success('Form successfully Submitted');
      setFormData({
        email_address: '',
        name: '',
        nationality: '',
        phone_number: '',
        city: '',
        position: '',
        note: '',
      });
      setCv(null);
      setProfileImg(null);
    } catch (err: any) {
      setLoading(false);
      const errMessage = getErrorMessge(err);
      toast.error(errMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="px-4 lg:px-16 py-8">
      <ul className="flex gap-10">
        <li className="lg:basis-[50%] basis-full shrink-0 grow-0 py-16 ">
          <div>
            <h1 className="text-2xl font-bold">Start Your journey</h1>
            <small>
              Use this form to submit your CV. A member of our HR team will be
              in touch as-soon-as possible to discuss this opportunity should
              your application be of interest.
            </small>
          </div>
          <form action="" className="flex flex-col py-6 gap-6">
            <div className="flex  border rounded-lg px-3 py-3 relative focus-withtin:border-gray-400 group">
              <label className="absolute pointer-events-none text-sm left-2 flex items-center cursor-text group-focus-within:-top-2 bg-white px-2 group-focus-within:text-xs transition-all duration-75">
                Full name *
              </label>
              <input
                value={formData.name}
                onChange={(e) =>
                  handleInputChange(e.target.name, e.target.value)
                }
                name="name"
                type="text"
                id="fullname"
                className="outline-0 grow"
              />
            </div>
            {error.name && (
              <p className="text-sm text-primary-500">{error.name}</p>
            )}
            <div className="flex border rounded-lg px-3 py-3 relative focus-withtin:border-gray-400 group">
              <label className="absolute pointer-events-none text-sm left-2 flex items-center cursor-text group-focus-within:-top-2 bg-white px-2 group-focus-within:text-xs transition-all duration-75">
                Email Address *
              </label>
              <input
                value={formData.email_address}
                onChange={(e) =>
                  handleInputChange(e.target.name, e.target.value)
                }
                name="email_address"
                type="email"
                id="fullname"
                className="outline-0 grow"
              />
            </div>
            {error.email_address && (
              <p className="text-sm  text-primary-500">{error.email_address}</p>
            )}
            <ul className="flex flex-wrap gap-4">
              <li className="grow">
                <div className="flex border rounded-lg px-3 py-3 relative focus-withtin:border-gray-400 group">
                  <label className="absolute pointer-events-none text-sm left-2 flex items-center cursor-text group-focus-within:-top-2 bg-white px-2 group-focus-within:text-xs transition-all duration-75">
                    Phone number *
                  </label>
                  <input
                    value={formData.phone_number}
                    onChange={(e) =>
                      handleInputChange(e.target.name, e.target.value)
                    }
                    name="phone_number"
                    type="tel"
                    id="fullname"
                    className="outline-0 grow"
                  />
                </div>
                {error.phone_number && (
                  <p className="text-sm text-primary-500">
                    {error.phone_number}
                  </p>
                )}
              </li>
              <li className="grow">
                <div className="flex border rounded-lg px-3 py-3 relative focus-withtin:border-gray-400 group">
                  <label className="absolute pointer-events-none text-sm left-2 flex items-center cursor-text group-focus-within:-top-2 bg-white px-2 group-focus-within:text-xs transition-all duration-75">
                    Nationality/State *
                  </label>
                  <input
                    value={formData.nationality}
                    onChange={(e) =>
                      handleInputChange(e.target.name, e.target.value)
                    }
                    name="nationality"
                    type="text"
                    id="fullname"
                    className="outline-0 grow"
                  />
                </div>
                {error.nationality && (
                  <p className="text-sm  text-primary-500">
                    {error.nationality}
                  </p>
                )}
              </li>
            </ul>
            <ul className="flex flex-wrap gap-4">
              <li className="grow">
                <div className="flex border rounded-lg px-3 py-3 relative focus-withtin:border-gray-400 group">
                  <label className="absolute pointer-events-none text-sm left-2 flex items-center cursor-text group-focus-within:-top-2 bg-white px-2 group-focus-within:text-xs transition-all duration-75">
                    City/Street *
                  </label>
                  <input
                    value={formData.city}
                    onChange={(e) =>
                      handleInputChange(e.target.name, e.target.value)
                    }
                    name="city"
                    type="text"
                    id="fullname"
                    className="outline-0 grow"
                  />
                </div>
                {error.city && (
                  <p className="text-sm  text-primary-500">{error.city}</p>
                )}
              </li>
              <li className="grow">
                <div className="flex border rounded-lg px-3 py-3 relative focus-withtin:border-gray-400 group">
                  <label className="absolute pointer-events-none text-sm left-2 flex items-center cursor-text group-focus-within:-top-2 bg-white px-2 group-focus-within:text-xs transition-all duration-75">
                    Position Applied For *
                  </label>
                  <input
                    value={formData.position}
                    onChange={(e) =>
                      handleInputChange(e.target.name, e.target.value)
                    }
                    name="position"
                    type="text"
                    id="fullname"
                    className="outline-0 grow"
                  />
                </div>
                {error.position && (
                  <p className="text-sm  text-primary-500">{error.position}</p>
                )}
              </li>
            </ul>
            <ul className="flex flex-wrap gap-4">
              <li className="grow">
                <div className="flex border rounded-lg px-3 py-3 relative focus-withtin:border-gray-400 group">
                  <label className="absolute pointer-events-none left-2 flex items-center cursor-text -top-2 bg-white px-2 text-xs transition-all duration-75">
                    Upload CV (format Docx or PDF) *
                  </label>
                  <input
                    type="file"
                    id="cv"
                    className="outline-0 grow text-sm"
                    name="cv"
                    onChange={handleFileUpload}
                  />
                </div>
                {error.cv && (
                  <p className="text-sm  text-primary-500">{error.cv}</p>
                )}
              </li>
              <li className="grow">
                <div className="flex border rounded-lg px-3 py-3 relative focus-withtin:border-gray-400 group">
                  <label className="absolute pointer-events-none left-2 flex items-center cursor-text -top-2 bg-white px-2 text-xs transition-all duration-75">
                    Upload Profile Picture (format: PNG) *
                  </label>
                  <input
                    type="file"
                    id="profileImg"
                    className="outline-0 grow text-sm"
                    name="profileImg"
                    onChange={handleFileUpload}
                  />
                </div>
                {error.profileImage && (
                  <p className="text-sm  text-primary-500">
                    {error.profileImage}
                  </p>
                )}
              </li>
            </ul>
            <div className="flex border rounded-lg px-3 py-3 relative focus-withtin:border-gray-400 group">
              <label className="absolute pointer-events-none left-2 flex items-center cursor-text -top-2 bg-white px-2 text-xs transition-all duration-75">
                Short note about yourself*
              </label>
              <textarea
                className="outline-0 grow text-sm resize-none"
                rows={4}
                cols={40}
                value={formData.note}
                name="note"
                onChange={(e) =>
                  handleInputChange(e.target.name, e.target.value)
                }
              ></textarea>
            </div>
            {error.note && (
              <p className="text-sm  text-primary-500">{error.note}</p>
            )}
            <div>
              <button
                type="submit"
                onClick={apply}
                className="px-14 py-3 font-semibold rounded-full bg-primary-500 text-sm text-white"
              >
                {loading ? 'Loading...' : 'Send'}
              </button>
            </div>
          </form>
        </li>
        <li className="hidden relative lg:flex grow-0 p-8">
          <Image
            src={imgPeople}
            alt="image of people"
            className="w-full object-contain"
          />
        </li>
      </ul>
    </section>
  );
};

export default Apply;
